import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_CIRCLE_CHECK: GlameraIconDefinition = {
  name: 'circle-check',
  viewBox: '0 0 24 24',
  svg: `
    <circle class="glm-circle-check-icon-ring" cx="12" cy="12" r="10"></circle>
    <path class="glm-circle-check-icon-mark" d="m9 12 2 2 4-4"></path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-circle-check-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './circle-check.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class CircleCheckIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_CIRCLE_CHECK;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
